<div class="padding-10">
    <button [attr.guide]="'payment-btn-1' + '__' + sanitizeUrl(url)" [disabled]="disable" (click)="createRzpayOrder()" 
    style="color:white" class="primary padding-10" mat-flat-button>PAY NOW</button>
  </div>